/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import gql from 'graphql-tag';
import { compact, filter, map } from 'lodash';

import logger from 'js/app/loggerSingleton';

import { Typography2 } from '@coursera/cds-core';

import withFragments from 'bundles/graphql/components/withFragments';
import type { PartnerNamesFragment } from 'bundles/partners-graphql/components/__generated__/PartnerNamesFragment';

type Props = {
  partners: PartnerNamesFragment;
};

// This is used by external bundles, not within the partners bundle.

export const PartnerNames = (props: Props) => {
  const {
    partners: { elements },
  } = props;

  if (!elements) {
    return null;
  }

  const names = map(
    filter(compact(elements), (partner) => {
      if (partner === null) {
        return false;
      }

      const { id, name } = partner;

      if (!name) {
        logger.error(`Partner with id ${id} does not have a name`);
      }
      return !!name;
    }),
    'name'
  );
  return (
    <Typography2 variant="bodySecondary" component="span">
      {names.join(', ')}
    </Typography2>
  );
};

export default withFragments({
  membership: gql`
    fragment PartnerNamesFragment on PartnersV1Connection {
      elements {
        id
        name
      }
    }
  `,
})(PartnerNames);
